export enum ExperienceDateType {
    Exact = 0,
    YearOnly = 1,
}

export const ExperienceDateTypeOptions = [
    {
        id: ExperienceDateType.Exact,
        name: 'Exact',
    },
    {
        id: ExperienceDateType.YearOnly,
        name: 'Year Only',
    },
];
